import IconFirstStep from '@/assets/icons/Statistics/IconFirstStep';
import IconFourthStep from '@/assets/icons/Statistics/IconFourthStep';
import IconSecondStep from '@/assets/icons/Statistics/IconSecondStep';
import IconThirdStep from '@/assets/icons/Statistics/IconThirdStep';

interface IStepCards {
  StepIcon: React.FC;
  description: string;
  buttonText: string;
  buttonAction: () => void;
}

interface StepCardsProps {
  prepaid: boolean;
  completeData: () => void;
  verifyCoverage: () => void;
  recharge: () => void;
  sendShipment: () => void;
}

export const StepCards = ({
  prepaid,
  completeData,
  verifyCoverage,
  recharge,
  sendShipment,
}: StepCardsProps): IStepCards[] => [
  {
    StepIcon: IconFirstStep,
    description: 'Verifica y completa tus datos de registro y de facturación.',
    buttonText: 'Completar datos',
    buttonAction: completeData,
  },
  {
    StepIcon: IconSecondStep,
    description: 'Verifica que tu envío llegue a donde quieras.',
    buttonText: 'Verificar cobertura',
    buttonAction: verifyCoverage,
  },
  ...(prepaid
    ? [
        {
          StepIcon: IconThirdStep,
          description: 'Abona saldo a tu cuenta.',
          buttonText: 'Recargar',
          buttonAction: recharge,
        },
      ]
    : []),
  {
    StepIcon: IconFourthStep,
    description: '¡Estás listo para tu primer envío!',
    buttonText: 'Haz un envío',
    buttonAction: sendShipment,
  },
];
